// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__SNrQ9","content":"Spinner_content__raRGU","spinner":"Spinner_spinner__x40ah","title":"Spinner_title__HnUz1","description":"Spinner_description__DRdN9"};